import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { merge, ReplaySubject, Subject } from 'rxjs';
import { DataListingRequestStatus, DataListingRequest, User } from '@interfaces';
import { AvailableLanguages } from '@constants';
import { UsersFacade } from '@state/users';
import { DataListingRequestModalService } from '../modals/data-listing-request-modal/data-listing-request-modal.service';
import { takeUntil } from 'rxjs/operators';
import moment from 'moment/moment';

@Component({
  selector: 'app-user-settings-list-of-requests',
  templateUrl: './user-settings-list-of-requests.component.html',
  styleUrls: ['./user-settings-list-of-requests.component.scss'],
  standalone: false,
})
export class UserSettingsListOfRequestsComponent implements OnInit, OnDestroy {
  private readonly usersFacade = inject(UsersFacade);
  private readonly requestOwnDataModalService = inject(DataListingRequestModalService);

  private destroy$: Subject<boolean> = new ReplaySubject(1);

  public dataListingRequests$ = this.usersFacade.dataListingRequests$;
  public loadingDataListingRequest$ = this.usersFacade.loadingDataListingRequest$;

  @Input() myself: User;
  @Input() currentLang: AvailableLanguages;

  public lastRequest: DataListingRequest;
  public allowSentDataListingRequest: boolean;

  public ngOnInit(): void {
    this.usersFacade.getAllRequestsDataListingSuccess$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ dataListingRequests }) => {
        if (!dataListingRequests?.length) {
          this.allowSentDataListingRequest = true;

          return;
        }

        const sorted = [...dataListingRequests].sort(
          (a, b) => moment(b.requestedAt).valueOf() - moment(a.requestedAt).valueOf()
        );

        this.lastRequest = sorted[0];

        this.allowSentDataListingRequest = this.lastRequest?.status !== DataListingRequestStatus.WAITING;
      });

    merge(this.usersFacade.requestDataListingSuccess$, this.usersFacade.requestDataListingError$)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.allowSentDataListingRequest = false;
      });

    this.usersFacade.getAllRequestsDataListing();
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public requestOwnData(): void {
    this.requestOwnDataModalService.open();
  }
}
